import React, { useState, useRef, useEffect } from "react";
import Map from "ol/Map.js";
import View from "ol/View.js";
import Overlay from "ol/Overlay.js";
import * as proj from "ol/proj";
import "ol/ol.css";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom
} from "ol/interaction";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import locSvg from "../assets/svg/sign up SVGs/Icon metro-location.svg";
import { Vector as VectorLayer } from "ol/layer";
import VectorSource from "ol/source/Vector";
import Cross from "../assets/svg/sidebar SVGs/Icon ionic-md-close-white.svg";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import PageNotFound from "../pages/404";
import { useSelector } from "react-redux";

export default function PopupMap(props) {
  const location = useLocation();
  const mapLoc = useSelector(state => state.homeReducer.loc);
  const coord = proj.fromLonLat(mapLoc);
  const mapModel = location.mapModel;
  let history = useHistory();

  const [center, setCenter] = useState(proj.fromLonLat([44.3661, 33.3152]));
  const [zoom, setZoom] = useState(7);
  const map = new Map({
    interactions: defaultInteractions().extend([new DragRotateAndZoom()]),

    target: null,
    layers: [
      new TileLayer({
        source: new OSM()
      })
    ],

    view: new View({
      center: center,
      zoom: zoom,
      minZoom: 6
    })
  });

  const popupRef = useRef();

  useEffect(() => {
    map.setTarget("map");
    const popup = new Overlay({
      element: popupRef.current
    });
    popup.setPosition(coord);
    map.addOverlay(popup);

    map.getView().setCenter(coord);
    const vectorL = new VectorLayer({
      source: new VectorSource()
    });
    map.addLayer(vectorL);
    map.on("moveend", () => {
      let center = map.getView().getCenter();
      let zoom = map.getView().getZoom();
      setCenter(center);
      setZoom(zoom);
    });
    map.on("click", evt => {
      map.getView().setCenter(evt.coordinate);
    });
    return () => {
      map.setTarget(null);
    };
  }, [mapModel]);
  const hideeMapModel = () => {
    // history.push({
    //   pathname: "/dashboard",
    //   mapModel: !mapModel
    // });
    history.goBack();
  };
  return (
    <div>
      {!mapModel || !mapLoc ? (
        <PageNotFound />
      ) : (
        <div className="my-64 h-full w-full clearfix">
          <div
            className={`w-full h-full bg-model absolute top-0 left-0 flex justify-center items-center z-40 ${
              mapModel ? "block" : "hidden"
            } `}
          >
            <div className=" w-10/12 h-75">
              <div className=" flex justify-end model-p">
                <button
                  onClick={() => {
                    hideeMapModel();
                  }}
                >
                  <img src={Cross} alt="Exsit" />
                </button>
              </div>
              <div
                id="map"
                style={{ width: "100%", height: "360px" }}
                // className=" fixed "
              />
              <div className="blue-circle" id="overlay" title="overlay"></div>
              <div
                className="blue-circle"
                id="popup"
                title="Welcome to OpenLayers"
                ref={popupRef}
              >
                <img src={locSvg} alt="lovSvg" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
